import React, { useEffect, useState } from "react";
import { MaterialButtons } from "./MaterialButtons";
import { SampleButtons } from "./SampleButtons";
import { Button } from "../ui/Button";

export const TitleButtons = ({
  title,
  items,
  activeItem,
  setActiveItem,
  sample = false,
  handleComplete,
  setActiveProduct,
}) => {
  const handleProductThickness = (value) => {
    setActiveProduct((prev) => ({
      ...prev,
      board: {
        ...prev.board,
        Debljina: value.name,
      },
    }));
  };
  const [activeThickness, setActiveThickness] = useState(null);
  useEffect(() => {
    if (activeThickness) {
      handleProductThickness(activeThickness);
    }
  }, [activeThickness]);

  return (
    <div className="styling-wrap__contents | js-conf-styling-wrap-content">
      <div className="styling-wrap__type">
        <p className="marcellus-25-400">{title}</p>
        {sample ? (
          <SampleButtons
            items={items}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
          />
        ) : (
          <MaterialButtons
            items={items}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
          />
        )}
      </div>
      {activeItem && activeItem.hasOwnProperty("board_thickness") && (
        <div className="styling-wrap__type">
          <p className="marcellus-25-400">Izaberite debljinu ploče</p>
          <div class="styling-wrap__type-items poppins-18-500">
            {activeItem.board_thickness &&
              activeItem.board_thickness.map((item) => {
                return (
                  <Button
                    activeItem={activeThickness}
                    setActiveItem={setActiveThickness}
                    item={item}
                  />
                );
              })}
          </div>
        </div>
      )}
      {activeThickness && (
        <div className="conf-color-picker__btn-wrap">
          <button
            type="button"
            className={`conf-color-picker__btn btn--slim btn green`}
            onClick={() => {
              handleComplete();
            }}
          >
            Nastavi
          </button>
        </div>
      )}
      {activeItem && activeItem.next_step && (
        <div className="conf-color-picker__btn-wrap">
          <button
            type="button"
            className={`conf-color-picker__btn btn--slim btn green`}
            onClick={() => {
              handleComplete();
            }}
          >
            Nastavi
          </button>
        </div>
      )}
      {activeItem &&
        activeItem.hasOwnProperty("has_colors") &&
        !activeItem.has_colors && (
          <div className="conf-color-picker__btn-wrap">
            <button
              type="button"
              className={`conf-color-picker__btn btn--slim btn green`}
              onClick={() => {
                handleComplete();
              }}
            >
              Nastavi
            </button>
          </div>
        )}
    </div>
  );
};
